import React from 'react';
import { Upload } from 'lucide-react';

interface BannerUploadFieldProps {
  value: string;
  onChange: (value: string) => void;
  onUpload: (file: File) => void;
  label: string;
  placeholder?: string;
  className?: string;
  accept?: string;
  onMouseMove?: (e: React.MouseEvent<HTMLInputElement>, url: string) => void;
  onMouseLeave?: () => void;
}

const BannerUploadField: React.FC<BannerUploadFieldProps> = ({
  value,
  onChange,
  onUpload,
  label,
  placeholder = 'Enter URL',
  className = '',
  accept = '.jpg,.jpeg,.png,.gif',
  onMouseMove,
  onMouseLeave,
}) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      onUpload(e.target.files[0]);
    }
  };

  return (
    <div className={`mb-5 ${className}`}>
      <label className='block text-blue-400 text-sm font-medium mb-2'>{label}</label>
      <div className='w-full h-[60px] border border-dashed border-gray-600 bg-[#212a40] rounded-md flex items-center'>
        <input
          type='text'
          value={value}
          onChange={e => onChange(e.target.value)}
          className='flex-grow h-full bg-transparent px-4 text-white border-none focus:outline-none'
          placeholder={placeholder}
          onMouseMove={onMouseMove ? e => onMouseMove(e, value) : undefined}
          onMouseLeave={onMouseLeave}
        />
        <button
          onClick={() => fileInputRef.current?.click()}
          className='h-full px-4 bg-[#2a334a] text-white border-l border-gray-600 hover:bg-[#344058] transition-colors'
        >
          <Upload size={16} />
        </button>
        <input ref={fileInputRef} type='file' className='hidden' onChange={handleFileChange} accept={accept} />
      </div>
    </div>
  );
};

export default BannerUploadField;
